export default "__VITE_ASSET__B_WbEBI8__"